import type { ProductColor } from "../../aysa_api/models/product_color.types";
import type { ProductImage } from "../../aysa_api/models/product_images.types";

export enum ProductSelection_DisplayType {
  UNSPECIFIED = 0,
  COLOR_LIST = 1,
}

export interface ProductSelection {
  // This should include the current product as well as all siblings, excluding sold out siblings.
  // If there is only one product color (the one that is currently displayed), it should be empty.
  // If there is only one product color and the product is second hand, it should be a list with just this product.
  items: ProductSelection_Item[];
  // Always true except for second hand products
  showColorNames: boolean;
  // We want to display product selections differently based on their type.
  // For example, some products like beauty assortment may have long lists of color variants.
  displayType: ProductSelection_DisplayType;
}

export interface ProductSelection_Item {
  id: number;
  colors: ProductColor[];
  path: string;
  // May be the bust image or a specific image which is only used as a thumbnail.
  thumbnailImage: ProductImage;
  // Color label (uppercase) for current product selection.
  // May be a simple label like 'Red' but also a combination of colors in the format of 'Black / White'.
  colorLabel: string;
  // Indicates if the item is out of stock.
  isSoldOut: boolean;
}
